import { keyframes } from '@mui/material/styles';

export const borderAnimation = keyframes`
  0% { border-color: secondary.main; }
  25% { border-color: primary.main; }
  50% { border-color: accent.main; }
  75% { border-color: primary.main; }
  100% { border-color: transparent; }
`;

const springIn = keyframes`
  0% { transform: translateY(-100%) }
  60% { transform: translateY(20%) }
  80% { transform: translateY(-5%); }
  100% { transform: translateY(0); }
`;

const springOut = keyframes`
  0% { transform: translateY(0); }
  20% { transform: translateY(-5%); }
  40% { transform: translateY(20%); }
  100% { transform: translateY(-100%) }
`;

export const jump = keyframes`
  0% { transform: scale(1) translate(50%, -50%) translateY(0); }
  20% { transform: scale(1) translate(50%, -50%) translateY(-5px); }
  40% { transform: scale(1) translate(50%, -50%) translateY(0); }
  100% { transform: scale(1) translate(50%, -50%) translateY(0); }
`;

export const animationSpring = `${springIn} 0.5s forwards, ${springOut} 0.5s 2.5s forwards`;
export const animationTimingStyle = 'cubic-bezier(0.34, 1.56, 0.64, 1)';
export const animationEaseOut = 'cubic-bezier(0.0, 0, 0.2, 1)';
